import { createContext as t } from "react";
function e() {
  return t(void 0);
}
function r() {
  return n;
}
const n = e();
export {
  r as getTableContext
};
